import BoldSmallText from '@/components/BoldSmallText';
import { BREAKPOINT } from '@/constants/enum';
import { Banner, Button, Collapsible, Icon, IconSource } from '@shopify/polaris';
import { ChevronDownIcon, ChevronUpIcon, XIcon, QuestionCircleIcon } from '@shopify/polaris-icons';
import { ReactNode, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

interface IProps {
  bannerTitle?: string;
  bannerContent?: ReactNode;
  onClose?: () => void;
  collapsible?: boolean;
  icon?: IconSource;
  isVisible?: boolean;
}

export default function CollapsibleBanner(props: IProps) {
  const [expandedInfo, setExpandedInfo] = useState(!props.collapsible);
  const isMobile = useMediaQuery({ maxWidth: BREAKPOINT.XS });
  return props.isVisible ? (
    <Banner hideIcon>
      <div className={`d-flex content-between ${isMobile ? 'flex-column-reverse' : ''}`}>
        <div className="d-flex align-center">
          <div className="wrap-header-icon">
            <Icon source={props.icon || QuestionCircleIcon} />
          </div>
          <BoldSmallText>{props.bannerTitle}</BoldSmallText>
        </div>
        {props.onClose || props.collapsible ? (
          <div className={`d-flex ${isMobile ? 'justify-end' : ''}`} style={{ gap: '8px' }}>
            {props.onClose ? <Button variant="plain" icon={XIcon} onClick={props.onClose} /> : null}
            {props.collapsible ? (
              <Button
                variant="plain"
                icon={expandedInfo ? ChevronUpIcon : ChevronDownIcon}
                onClick={() => {
                  setExpandedInfo(!expandedInfo);
                }}
              />
            ) : null}
          </div>
        ) : null}
      </div>
      <div className="ml-32">
        <Collapsible open={expandedInfo} id="basic-collapsible-info" transition={{ duration: '500ms' }} expandOnPrint>
          {props.bannerContent}
        </Collapsible>
      </div>
    </Banner>
  ) : null;
}
